import React, { useState, useEffect, useRef } from 'react'
import { BsThreeDotsVertical } from 'react-icons/bs';
import { customerActions } from '../../../../_actions';
import { useDispatch } from 'react-redux';
import ReactPaginate from 'react-paginate';
import { LuArrowUpDown } from "react-icons/lu";
import { MdEdit, MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { AiOutlineStop } from "react-icons/ai";
import { MdPowerSettingsNew } from "react-icons/md";
import { formatWithOffset,formatWithoutOffset } from '../../../../_helpers/helper';


const useClickOutside = (handler) => {
	const menuRef = useRef();
	const buttonRef = useRef();

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				menuRef.current &&
				!menuRef.current.contains(event.target) &&
				buttonRef.current &&
				!buttonRef.current.contains(event.target)
			) {
				handler();
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [handler]);

	return { menuRef, buttonRef };
};

const Table = ({ filterData, setFilterData, assignedCustomer, theadData, tbodyData, handleEdit, handleView, showMenu, isMenu, clickedUserId, handleUserBlock, handleUserDelete, userAccess, handlePageClick, size }) => {
	// const [sortValue, setSortValue] = useState({ sortBy: "", sortOrder: "" });
	const handleOrderChange = (e) => {
		const { name, value } = e.target;
		setFilterData({
			...filterData,
			[name]: value
		});
		// setSortValue({ ...sortValue, [name]: value });
	}
	const orderOptions = [
		{ value: "id", label: "Id" },
		{ value: "f_name", label: "First Name" },
		{ value: "l_name", label: "Last Name" },
		{ value: "weighbridge_id", label: "Weighbridge" },
		{ value: "expired_on", label: "Expired On" },
		{ value: "phone", label: "Phone" },
		{ value: "referred_by_name", label: "Referred By Name" },
		{ value: "license_key", label: "License Key" },
		{ value: "last_login", label: "Last Login" },
		{ value: "city", label: "City" },
		{ value: "created_at", label: "Created At" },
		{ value: "updated_at", label: "Updated At" },
		{ value: "near_expire", label: "Near Expire" }
	];

	const orderBy = [{ value: "ASC", label: "Asc" }, { value: "DESC", label: "Desc" }];
	const dispatch = useDispatch();
	const isExpiringSoon = (expiredOn) => {
		if (!expiredOn) return false;
		const currentDate = new Date();
		const expiryDate = new Date(expiredOn);
		const timeDifference = expiryDate - currentDate;
		const daysDifference = timeDifference / (1000 * 60 * 60 * 24);
		return daysDifference <= 7 && daysDifference >= 0;
	}
	const isExpired = (expiredOn) => {
		if (!expiredOn) return false;
		const currentDate = new Date();
		const expiryDate = new Date(expiredOn);
		return currentDate > expiryDate;
	}
	function sortFunction(index) {
		const sortKey = ['id', 'f_name', 'l_name', 'phone', 'city', 'weighbridge_id', 'license_key', 'referred_by_name', 'expired_on', 'last_login', 'status'];
		if (!sortKey[index]) return;
		setFilterData((p) => ({
			...p,
			sortBy: sortKey[index],
			sortOrder: p.sortOrder === "ASC" ? "DESC" : "ASC"
		}));
		dispatch(customerActions.customerList({ ...filterData, sortBy: sortKey[index] }, assignedCustomer));

	}
	function handelSortOrder() {
		dispatch(customerActions.customerList({ ...filterData, sortBy: filterData['sortBy'], sortOrder: filterData['sortOrder'] }, assignedCustomer));
	}
	const [openMenuId, setOpenMenuId] = useState(null);
	const { menuRef, buttonRef } = useClickOutside(() => {
		setOpenMenuId(null);
	});
	const toggleMenu = (id) => {
		setOpenMenuId(openMenuId === id ? null : id);
	};
	return (
		<div>
			<div className="py-4 bg-white space-y-4">
				<div className='flex justify-between items-center flex-wrap  pb-3'>
					<h1 className="text-xl font-semibold  xl:pb-0 pb-2">Recently Added Customers</h1>
					<div className='flex justify-between items-center space-x-3'>
						<div className='md:space-x-2 space-x-0'>
							<select className='px-2 py-1.5 bg-white border rounded-md outline-none' name='sortBy' value={filterData['sortBy']} onChange={handleOrderChange}>
								{orderOptions.map(opt =>
									<option value={opt.value}>{opt.label}</option>
								)}
							</select>
						</div>
						<div className='md:space-x-2 space-x-0'>
							<select className='px-2 py-1.5 bg-white border rounded-md outline-none' name='sortOrder' value={filterData['sortOrder']} onChange={handleOrderChange}>
								{orderBy.map(opt =>
									<option value={opt.value}>{opt.label}</option>
								)}
							</select>
						</div>
						<div>
							<button className='bgbtn rounded-md px-4 py-2' onClick={handelSortOrder}>Go</button>
						</div>
					</div>
				</div>
				<div className="overflow-x-auto">
					<table className="min-w-full text-sm text-left text-gray-500  border ">
						<thead className="text-black capitalize border-b bg-gray-100">
							<tr>
								{theadData.map((header, index) => (
									<th key={index} className="px-4 py-2 whitespace-nowrap space-x-3 font-medium text-gray-900 cursor-pointer hover:bg-gray-200" onClick={() => sortFunction(index)}>
										<div className='flex items-center space-x-1'>
											<span> {header}</span>
											{!["Status", "Actions", "Created By"].includes(header) && <LuArrowUpDown className='w-3 h-4 text-gray-500' />}
										</div>
									</th>
								))}
							</tr>
						</thead>
						<tbody>
							{tbodyData && tbodyData.total != 0 && tbodyData?.list?.map((row, index) => (
								<tr key={index} className={`whitespace-nowrap font-normal text-[#212121] border-b capitalize  ${isExpiringSoon(row.expired_on) ? "bg-red-200 hover:bg-red-300" : "bg-white hover:bg-gray-50"}`}>
									<td className="px-4 py-2"> {row.id} </td>
									<td className="px-4 py-2"> {row?.f_name || 'N/A'}</td>
									<td className="px-4 py-2"> {row?.l_name || 'N/A'}</td>
									<td className="px-4 py-2">{row.phone || 'N/A'}</td>
									<td className="px-4 py-2">{row.city || 'N/A'}</td>
									<td className="px-4 py-2">{row.weighbridge_id || 'N/A'}</td>
									<td className="px-4 py-2">{row.license_key || 'N/A'}</td>
									<td className="px-4 py-2">{row.referred_by_name || 'N/A'}</td>
									<td className="px-4 py-2">{row.expired_on ? formatWithOffset(row.expired_on) : 'N/A'}</td>
									<td className="px-4 py-2">{row.last_login ? formatWithOffset(row.last_login) : 'N/A'}</td>
									{/* <td className="px-4 py-2">{row.last_login ? formatWithoutOffset(row.last_login) : 'N/A'}</td> */}
									<td className="px-4 py-2">{row.created_at ? formatWithoutOffset(row.created_at) : 'N/A'}</td>
									<td className="px-4 py-2">{row.admin_name ? row.admin_name : ''}</td>
									<td
										className={`px-4 py-2 ${row?.expire_on_backup ? 'text-red-500' : isExpired(row?.expired_on) ? 'text-yellow-500' : 'text-green-500'}`}>
										{/* {row.status === 1 ? 'Active' : row.status === 2 ? 'Stoped' : 'Expired'} */}
										{row?.expire_on_backup ? 'Stoped' : isExpired(row?.expired_on) ? 'Expired' : 'Active'}
									</td>
									<td className="py-2 px-3 text-center ">
										<div className='relative '>
											<button
												ref={openMenuId === row?.id ? buttonRef : null}
												className="w-8 h-8 rounded-md   flex justify-center items-center  cursor-pointer  transition-colors "
												onClick={() => toggleMenu(row?.id)}
											>
												<BsThreeDotsVertical />
											</button>
											{openMenuId === row?.id && (
												<div
													ref={menuRef} className="absolute -bottom-12  right-16 mt-2 w-fit bg-white z-50">
													<ul className=" rounded-md  shadow space-y-1 text-left ">
														{userAccess && userAccess.includes("edit_customer") &&
															<li className="flex items-center space-x-3 px-4 py-1 border-b text-gray-700 bghover cursor-pointer transition-colors" onClick={() => handleEdit(row)}>
																<span><MdEdit className='w-5 h-5' /></span>
																<span>Edit</span>
															</li>
														}
														{userAccess && userAccess.includes("expiry_cust_manag") &&
															<li className="flex items-center space-x-3 px-4 py-1 border-b text-gray-700 bghover cursor-pointer transition-colors" onClick={() => handleUserDelete(row)}>
																<span><RiDeleteBinLine className='w-5 h-5' /></span>
																<span>Delete</span>
															</li>
														}
														{userAccess && userAccess.includes("view_customer") &&
															<li className="flex items-center space-x-3 px-4 py-1 border-b text-gray-700 bghover cursor-pointer transition-colors" onClick={() => handleView(row)}>
																<span><MdOutlineRemoveRedEye className='w-5 h-5' /></span>
																<span>View</span>
															</li>
														}
														{userAccess && userAccess.includes("expiry_cust_manag") &&
															<li className="flex items-center space-x-3 px-4 py-1 border-b text-gray-700 bghover cursor-pointer transition-colors" onClick={() => handleUserBlock({ id: row.id, action: row.status === 1 ? "BLOCK" : "UN_BLOCK" })}>
																<span>{row.status && row.status === 2 ? <MdPowerSettingsNew /> : <AiOutlineStop className='w-4 h-4' />}</span>
																<span>{row.status && row.status === 2 ? 'Start Subscription' : 'Stop Subscription'}</span>
															</li>
														}
													</ul>
												</div>
											)}
										</div>

									</td>
								</tr>
							))}
						</tbody>
					</table>
					{tbodyData && tbodyData.total === 0 && <div className='flex items-center justify-center mt-[20px]'><h2>Customer not exists.</h2></div>}
				</div>
				{tbodyData && tbodyData.total && tbodyData.total > size && <div className='py-2 pt-6'>
					<ReactPaginate
						previousLabel={'Prev'}
						nextLabel={'Next'}
						breakLabel={'...'}
						breakClassName={'break-me'}
						pageCount={tbodyData.total / size}
						marginPagesDisplayed={1}
						pageRangeDisplayed={1}
						onPageChange={handlePageClick}
						containerClassName={'pagination'}
						pageClassName={'page-cls'}
						activeClassName={'active'}
						total={tbodyData.total}
						size={size}
					/>
				</div>}
			</div>
		</div>
	)
}

export default Table